export enum UserError {
  UNKNOWN_USER = "unknown_user",
  DUPLICATE_USER = "duplicate_user",
  EMAIL_INUSE = "email_in_use",
  WALLET_INUSE = "wallet_in_use",
}
